var React = require('react');
var ReactDom = require('react-dom');
var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');
var cartCount = "";
var labels = require("CartCountLabels");
const cartCountEventName = 'cartCountUpdate';

class CartCount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: props.firstName,
            displayedCartCount: []
        };

        this.isInitialLoad = true;
        this.fetchShoppingCartCount = this.fetchShoppingCartCount.bind(this);
        this.getHeaderButton = this.getHeaderButton.bind(this);
        this.getHeaderButtonClass = this.getHeaderButtonClass.bind(this);
        this.isOnCartPage = this.isOnCartPage.bind(this);
    }

    componentDidMount() {
        if (this.props.isLoggedIn) {
            this.fetchShoppingCartCount();
            window.addEventListener(cartCountEventName, this.fetchShoppingCartCount);
        }
    }

    componentWillUnmount() {
        window.removeEventListener(cartCountEventName, this.fetchShoppingCartCount);
    }

    isOnCartPage() {
        return window.location.pathname.includes('/cart');
    }

    fetchShoppingCartCount() {
        accountDataService.getData('shoppingCartCount').then((result) => {
            if (result && result.response && result.response.ResultStatus && result.response.ResultStatus.Success) {
                const oldCount = cartCount;
                cartCount = result.response.Count;
                this.setState({
                    displayedCartCount: cartCount
                }, () => {
                    if (!this.isInitialLoad && oldCount !== cartCount) {
                        const markers = document.querySelectorAll('.marker');
                        markers.forEach(marker => {
                            marker.classList.remove('animate-count');
                            void marker.offsetWidth; // Force reflow
                            marker.classList.add('animate-count');
                        });
                    }
                    this.isInitialLoad = false;
                });
            }
        });
    }

    getHeaderButtonClass(mobile) {
        return mobile ? "accordionItemHeading" : "utility-nav-item";
    }

    getHeaderButton(mobile) {
        const resultsNumber = cartCount;
        const label = (resultsNumber && !this.isOnCartPage()) ? <label className={"marker"}>{resultsNumber}</label> : null;
        return <a className="accordionItemHeading cartpath" href={cartCount > 0 ? "/cart" : "/shop-asa"}>
            <button className={this.getHeaderButtonClass(mobile)} key={"cartCount-button"}>
                {label}
                <svg width="19" height="17" viewBox="0 0 19 17" xmlns="http://www.w3.org/2000/svg">
                    <title>{labels.navigationTitle}</title>
                    <path d="M6.719 13.996c.282.282.424.617.424 1.004s-.142.722-.424 1.004a1.373 1.373 0 0 1-1.005.425c-.387 0-.721-.142-1.004-.425A1.373 1.373 0 0 1 4.286 15c0-.387.141-.722.424-1.004a1.373 1.373 0 0 1 1.004-.425c.387 0 .722.142 1.005.425zm10 0c.282.282.424.617.424 1.004s-.142.722-.424 1.004a1.373 1.373 0 0 1-1.005.425c-.387 0-.721-.142-1.004-.425A1.373 1.373 0 0 1 14.286 15c0-.387.141-.722.424-1.004a1.373 1.373 0 0 1 1.004-.425c.387 0 .722.142 1.005.425zM18.57 2.857v5.714a.692.692 0 0 1-.184.475.706.706 0 0 1-.452.24L6.283 10.647c.097.447.146.707.146.782 0 .119-.09.357-.268.714h10.268c.193 0 .36.07.502.212a.686.686 0 0 1 .212.502c0 .194-.07.361-.212.502a.686.686 0 0 1-.502.212H5a.686.686 0 0 1-.502-.212.686.686 0 0 1-.212-.502c0-.082.03-.199.089-.351.06-.153.119-.287.179-.402.06-.116.14-.264.24-.447.1-.182.158-.292.173-.329L2.99 2.143H.714a.686.686 0 0 1-.502-.212A.686.686 0 0 1 0 1.429c0-.194.07-.361.212-.503A.686.686 0 0 1 .714.714h2.857a.68.68 0 0 1 .536.246c.052.067.1.158.145.273.045.116.075.212.09.29a59.071 59.071 0 0 1 .111.62h13.404c.194 0 .361.07.502.212a.686.686 0 0 1 .212.502z" fill="#FFF" fillRule="evenodd" className={"cart-icon"} />
                </svg>
            </button>
        </a>;
    }

    render() {
        const desktopButton = this.getHeaderButton(false);
        const mobileButton = this.getHeaderButton(true);

        const desktopNode = document.getElementsByClassName('cart-count-desktop')[0];
        const mobileNode = document.getElementsByClassName('cart-count-mobile')[0];

        if (!desktopNode) return null;

        return [ReactDom.createPortal([desktopButton], desktopNode),
        ReactDom.createPortal([mobileButton], mobileNode)];
    }
}

module.exports = CartCount;